<mainpanel Title="My Profile" [hideSearchBox]="true" [hideSearchDropdown]="false" [hideSearchDropdown]="true">
  <div actions>
    <button role="button" class="btn btn-success btn-fill btn-lg text-white" (click)="onSave()">Save</button>
  </div>
  <div content>
    <div class="container">
      <div class="row mt-6">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <h2>General Credential</h2>
            </div>
            <div class="card-body">
              <div class="form-label-group">
                <input type="text" id="inputName" [(ngModel)]="user.UserName" class="form-control"
                  placeholder="Username" />
                <label for="inputName">Username</label>
              </div>
              <div class="form-label-group">
                <input type="email" id="email" class="form-control" #email="ngModel" [(ngModel)]="user.Email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" name="email" required />
                <label for="email">Email</label>
                <ng-container *ngIf="email.touched && email.invalid">
                  <span class="text-danger" *ngIf="email.errors?.['required']"> Email required.</span>
                  <span class="text-danger" *ngIf="email.errors?.['pattern']"> {{user.Email}} is not a valid
                    email</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <h2>Change Password</h2><small class="text-muted h6">Leave blank if you do not want to change</small>
            </div>
            <div class="card-body">
              <div class="form-label-group">
                <input type="password" id="inputPassword" class="form-control" name="password" placeholder="Password"
                  required [(ngModel)]="newPassword" #password="ngModel" />
                <label for="inputPassword">Password</label>
                <i class="control-label text-danger" *ngIf="password.touched && password.invalid"> required.</i>
              </div>

              <div class="form-label-group">
                <input type="password" id="inputrepassword" class="form-control" placeholder="Re-Password"
                  [(ngModel)]="rePassword" #rePasswordModel="ngModel" required />

                <label for="inputRepassword">Re-Password</label>
                <i class="control-label text-danger"
                  *ngIf="(rePassword != newPassword) && (rePasswordModel.touched || rePasswordModel.dirty)"> These
                  passwords
                  don't match.</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</mainpanel>